import { Injectable } from '@angular/core';

import { AlertService } from '../ui.module/alert.service';

export function alertGlobalControlLevelIncreasedInnerHTML({ official, cpu, gcl }) {
    return `
    <p class='--text-left'>
        Global Control Level has been increased!
        <br>
        ${ official ? `
            Your CPU Limit is now <strong>${ cpu } CPU</strong>,
            and you can control <strong>${ gcl } rooms</strong>.
        ` : `
            You can control <strong>${ gcl } rooms</strong> now.
        ` }
        <br>
        <a class='_link' target='_blank' href='http://docs.screeps.com/control.html' app-nw-external-link>Learn more</a></p>
    </p>
    `;
}

@Injectable()
export class ShowDlgGCLIncreasedService {
    constructor(
        private _alert: AlertService,
    ) {
    }

    show(data: any): Promise<void> {
        return this._alert.show({ data: {
            title: '',
            innerHTML: alertGlobalControlLevelIncreasedInnerHTML(data)
        }});
    }
}
